// src/components/ProjectOverview.jsx
import React from "react";
import ProjectOverviewKpi from "./ProjectOverviewKpi";

export default function ProjectOverview({ projectId = null }) {
  return (
    <div className="space-y-4">
      <ProjectOverviewKpi projectId={projectId} />
    </div>
  );
}
